import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Heart, CircleDollarSign, ThumbsUp, Flame, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const medal = (i) => (i === 0 ? "text-[#F5B301]" : i === 1 ? "text-zinc-300" : i === 2 ? "text-amber-700" : "text-zinc-600");

export default function Rankings() {
  const [pitches, setPitches] = useState([]);
  useEffect(() => { api.get("/pitches/top10").then((r) => setPitches(r.data)); }, []);

  return (
    <main className="relative pt-28 pb-24 max-w-5xl mx-auto px-4 sm:px-6">
      <div className="noise-overlay" />
      <div className="text-left mb-12">
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight flex items-center gap-4">
          Top 10 <span className="gold-gradient-text">Pitches</span>
          <Trophy size={32} className="text-[#F5B301]" />
        </h1>
        <p className="mt-3 text-zinc-500 text-sm md:text-base max-w-lg">Ranked by EBN score — a blend of investor engagement, traction and pitch quality.</p>
      </div>
      <div className="space-y-4" data-testid="rankings-list">
        {pitches.map((p, i) => (
          <Link to={`/pitch/${p.id}`} key={p.id} data-testid={`ranking-row-${i + 1}`} className={`rounded-2xl bg-[#0d0d0d] border p-5 flex items-center gap-5 text-left gold-glow-hover group ${i === 0 ? "border-[#F5B301]/40" : "border-white/5"}`}>
            <span className={`font-heading font-bold text-2xl w-10 text-center ${medal(i)}`}>{i + 1}</span>
            <img src={p.thumbnail} alt={p.company} className="w-14 h-14 rounded-xl object-cover" />
            <div className="flex-1 min-w-0">
              <h2 className="font-heading font-semibold text-white text-lg truncate flex items-center gap-2 group-hover:text-[#F5B301] transition-colors">
                {p.company}
                <ArrowUpRight size={14} className="text-zinc-600 group-hover:text-[#F5B301] transition-colors" />
                {p.trending && (
                  <span data-testid={`ranking-trending-badge-${p.id}`} title={`+${p.weekly_hearts} hearts, +${p.weekly_dollars} dollars this week`} className="flex items-center gap-1 text-[10px] font-bold text-black px-2 py-0.5 rounded-full bg-gradient-to-r from-[#F5B301] to-orange-500 trending-badge shrink-0">
                    <Flame size={10} fill="black" /> Hot Streak
                  </span>
                )}
              </h2>
              <p className="text-xs text-zinc-500 truncate">{p.tagline} · {p.founder}</p>
              <div className="mt-1.5 flex gap-4 text-[11px] text-zinc-400">
                <span className="flex items-center gap-1"><Heart size={11} className="text-red-500" /> {p.hearts}</span>
                <span className="flex items-center gap-1"><CircleDollarSign size={11} className="text-[#F5B301]" /> {p.dollars}</span>
                <span className="flex items-center gap-1"><ThumbsUp size={11} className="text-blue-400" /> {p.likes}</span>
              </div>
            </div>
            <div className="text-right shrink-0">
              <p className="font-heading font-bold text-2xl text-[#F5B301]">{p.score}</p>
              <p className="text-[10px] uppercase tracking-widest text-zinc-600">EBN Score</p>
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}
